import React, { useState } from 'react';
import './Footer.css';
import SOPModal from './SOPModal';

const Footer: React.FC = () => {
  const [isSOPModalOpen, setIsSOPModalOpen] = useState(false);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <span className="copyright">&copy; 2025 (주)천일국제물류. All rights reserved.</span>
          <button
            className="footer-link-btn"
            onClick={() => setIsSOPModalOpen(true)}
          >
            납품대행-내국물품운영절차(SOP)
          </button>
        </div>
      </div>
      <SOPModal isOpen={isSOPModalOpen} onClose={() => setIsSOPModalOpen(false)} />
    </footer>
  );
};

export default Footer;
